import * as XLSX from 'xlsx';
import { toast } from 'sonner';

/**
 * Download data as an Excel (.xlsx) file.
 *
 * @param {Object}   options
 * @param {string}   options.filename     - "WWAGS_DCB_2026-04-30" (no extension)
 * @param {string}   options.sheetName    - "DCB" (defaults to "Sheet1")
 * @param {Array}    options.rows         - Array of objects (one row each).
 *                                          Object keys become column headers.
 * @param {Object[]} [options.sheets]     - Optional: multi-sheet export.
 *                                          [{ name, rows }, ...]. If supplied,
 *                                          `rows`/`sheetName` are ignored.
 * @param {Array}    [options.kpis]       - Optional KPI summary written above the
 *                                          first table:
 *                                          [{label, value}, ...]. Only used in
 *                                          single-sheet mode.
 */
export const exportToExcel = ({ filename, sheetName = 'Sheet1', rows, sheets, kpis }) => {
  try {
    const wb = XLSX.utils.book_new();

    if (Array.isArray(sheets) && sheets.length > 0) {
      sheets.forEach(({ name, rows: sheetRows }) => {
        const ws = XLSX.utils.json_to_sheet(sheetRows || []);
        XLSX.utils.book_append_sheet(wb, ws, (name || 'Sheet').slice(0, 31));
      });
    } else {
      if (!rows || rows.length === 0) {
        toast.error('Nothing to export');
        return;
      }
      let ws;
      if (kpis && kpis.length) {
        const kpiRows = kpis.map(k => ({ Metric: k.label, Value: k.value }));
        ws = XLSX.utils.json_to_sheet(kpiRows);
        XLSX.utils.sheet_add_json(ws, [{}], { origin: -1, skipHeader: true }); // blank row
        XLSX.utils.sheet_add_json(ws, rows, { origin: -1 });
      } else {
        ws = XLSX.utils.json_to_sheet(rows);
      }
      XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
    }

    const finalName = `${filename || 'WWAGS_Report'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, finalName);
    toast.success('Excel file downloaded');
  } catch (err) {
    console.error(err);
    toast.error('Failed to export Excel');
  }
};

export default exportToExcel;
